"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AI_CREATE_AG_UI_SSE_EVENT = exports.AI_CREATE_AG_UI_CUSTOM_EVENT = exports.AI_CREATE_STREAM_NODE = void 0;
/**
 * Graph nodes narrated in the AI create chat stream. Each executes once per
 * run, so the node name doubles as a stable tool-call id: a node re-entered
 * after a checkpoint continue reconciles onto the same timeline card.
 */
exports.AI_CREATE_STREAM_NODE = {
    ANALYZE_DEEP_LINK: 'analyzeDeepLink',
    ANALYZE_REFERENCE_URL: 'analyzeReferenceUrl',
    BUILD_SOURCE_STOREFRONT_LAYOUT: 'buildSourceStorefrontLayout',
    INGEST_PAGE_IMAGES: 'ingestPageImages',
    PROCESS_VIDEO: 'processVideo',
    ANALYZE_AD_CREATIVE: 'analyzeAdCreative',
    RESOLVE_PRODUCTS: 'resolveProducts',
    INGEST_PRODUCT_IMAGES: 'ingestProductImages',
    GENERATE_CONVERSION_HYPOTHESIS: 'generateConversionHypothesis',
    RANK_PERSONAS: 'rankPersonas',
    RANK_LAYOUT_REFERENCES: 'rankLayoutReferences',
    PREPARE_PRODUCT_CONTENT: 'prepareProductContent',
    PLAN_VARIANTS: 'planVariants',
    ANALYZE_LAYOUT_REFERENCE: 'analyzeLayoutReference',
    CREATE_STOREFRONT: 'createStorefront',
    GENERATE_LLM_CONTENT: 'generateLlmContent',
    CURATE_MEDIA: 'curateMedia',
    FINALIZE_CONTENT: 'finalizeContent',
    REWRITE_COPY: 'rewriteCopy',
    REVIEW_STOREFRONTS: 'reviewStorefronts',
    REVISE_STOREFRONTS: 'reviseStorefronts',
};
/** AG-UI CUSTOM event names for the create-specific payloads. */
exports.AI_CREATE_AG_UI_CUSTOM_EVENT = {
    NOTE: 'aiCreate.note',
};
/** Named SSE events on the create AG-UI stream; AG-UI payloads are unnamed. */
exports.AI_CREATE_AG_UI_SSE_EVENT = {
    PING: 'ping',
};
